import { useEffect } from 'react'

import AuthService from '../services/AuthService'

/**
 * Rinnova il JWT prima che scada, ma solo per chi sta davvero lavorando.
 *
 * Il token vive un'ora (ACCESS_TOKEN_EXPIRE_MINUTES lato digiscan-web, portato
 * da 24h a 1h con TREV-06) e `POST /api/auth/refresh` ne conia uno nuovo a
 * partire da uno ancora valido. Senza questo rinnovo l'ora scadeva in mezzo al
 * lavoro: l'interceptor su 401 pulisce il cookie e rimanda al portale, e quel
 * che non era stato salvato se ne va.
 *
 * Il rinnovo e' legato all'attivita' proprio per non annullare il motivo per
 * cui il TTL e' stato accorciato: una postazione di reparto lasciata aperta e
 * senza nessuno davanti scade lo stesso entro l'ora. Contano i segnali di
 * presenza (anche il solo movimento del puntatore), non il traffico verso le
 * API: il polling automatico di una pagina aperta terrebbe viva la sessione da
 * solo.
 */

export const REFRESH_EVERY_MS = 45 * 60 * 1000 // 3/4 della vita del token
export const ACTIVITY_WINDOW_MS = 15 * 60 * 1000

const ACTIVITY_EVENTS = [
  'pointerdown',
  'pointermove',
  'keydown',
  'wheel',
  'touchstart',
]

const useSessionRefresh = (isAuthenticated) => {
  useEffect(() => {
    if (!isAuthenticated) return undefined

    let lastActivityAt = Date.now()
    const markActivity = () => {
      lastActivityAt = Date.now()
    }
    ACTIVITY_EVENTS.forEach((event) =>
      document.addEventListener(event, markActivity, { passive: true })
    )

    const timer = setInterval(async () => {
      if (Date.now() - lastActivityAt > ACTIVITY_WINDOW_MS) return
      try {
        // Il cookie lo riscrive la risposta del rinnovo (Set-Cookie
        // HttpOnly): qui basta chiedere.
        await AuthService.refreshToken()
      } catch (e) {
        // Il rinnovo puo' fallire perche' il token e' gia' morto o perche' la
        // rete e' saltata: in entrambi i casi il biglietto che c'e' resta dov'e'
        // e la prima chiamata rifiutata fa il suo lavoro (401 -> interceptor).
        console.warn('[useSessionRefresh] rinnovo non riuscito', e)
      }
    }, REFRESH_EVERY_MS)

    return () => {
      clearInterval(timer)
      ACTIVITY_EVENTS.forEach((event) =>
        document.removeEventListener(event, markActivity)
      )
    }
  }, [isAuthenticated])
}

export default useSessionRefresh
